import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, OnInit } from '@angular/core';
import { UserSearchTextForm } from '../../../form-model/user-search-text.form.model';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { RouterModule } from '@angular/router';
import "@maersk-global/mds-components-core/mc-input-group";
import "@maersk-global/mds-components-core/mc-input";
import "@maersk-global/mds-components-core/mc-button";

@Component({
  selector: 'app-user-search',
  imports: [FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './user-search.component.html',
  styleUrl: './user-search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserSearchComponent implements OnInit {
  @Input({ required: true }) userSearchTextForm!: FormGroup<UserSearchTextForm>;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.addControlsToTheFormGroup();
  }

  applySearchTextFilters(): void {
    this.userSearchTextForm.controls.appliedUserSearchTextFilter.setValue(true);
  }

  isControlInErrorState(control: FormControl): boolean | null {
    if (control.invalid && control.touched) {
      return true;
    }
    return null;
  }

  private addControlsToTheFormGroup() {
    this.userSearchTextForm.addControl('searchText', this.formBuilder.control<string | null>(null));
    this.userSearchTextForm.addControl('appliedUserSearchTextFilter', this.formBuilder.control<boolean | null>(null));
  }
}
